import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ShippingTerm } from '../../models'

export const ShippingTermMock = Factory.Sync.makeFactory<ShippingTerm>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words()),
  active: true,
  description: Factory.each(() => faker.random.words()),
})
